export default Object.freeze({
  Brown: 'brown',
  Yellow: 'yellow',
  GreenLight: 'green-light',
  Violet: 'violet',
  Green: 'green',
  Pink: 'pink',
  Orange: 'primary-2',
  OrangeLight: 'orange-light',
  Red: 'primary-4',
  Gray: 'gray',
});
